var map = {
	"app/activities/brainstorming/brainstorming.module": [
		"./src/app/activities/brainstorming/brainstorming.module.ts",
		"common",
		"brainstorming.module"
	],
	"app/activities/participant-questions/participant-questions.module": [
		"./src/app/activities/participant-questions/participant-questions.module.ts",
		"common",
		"participant-questions.module"
	],
	"app/activities/rating/rating.module": [
		"./src/app/activities/rating/rating.module.ts",
		"common",
		"rating.module"
	],
	"app/activities/sorting/sorting.module": [
		"./src/app/activities/sorting/sorting.module.ts",
		"common",
		"sorting.module"
	],
	"app/auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth.module",
		"common"
	],
	"app/help-support/help-support.module": [
		"./src/app/help-support/help-support.module.ts",
		"common",
		"help-support.module"
	],
	"app/invite/invite.module": [
		"./src/app/invite/invite.module.ts",
		"common",
		"invite.module"
	],
	"app/my-account/my-account.module": [
		"./src/app/my-account/my-account.module.ts",
		"common",
		"my-account.module"
	],
	"app/my-projects/my-projects.module": [
		"./src/app/my-projects/my-projects.module.ts",
		"common",
		"my-projects.module"
	],
	"app/notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"common",
		"notifications.module"
	],
	"app/participant/participant.module": [
		"./src/app/participant/participant.module.ts",
		"common",
		"participant.module"
	],
	"app/project/project.module": [
		"./src/app/project/project.module.ts",
		"common",
		"project.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main